import React from 'react'
import PropTypes from 'prop-types'
import Text from '../formatting/Text'

const legendColor = color => {
  if (color === 'green') {
    return 'bg-available'
  }

  if (color === 'orange') {
    return 'bg-pending'
  }

  return color
}

const legendBorderColor = color => {
  let borderClasses = 'bg-transparent border-2';

  switch (color) {
    case 'green':
      return `${borderClasses} border-available`
    case 'orange':
      return `${borderClasses} border-pending`
    default:
      return `${borderClasses} ${color.replace('bg-', 'border-')}`
  }
}

function LegendItem ({ children, className = '', color, colorHex = null, border }) {
  const styles = {}
  let colorClass = legendColor(color);

  if (colorHex !== null) {
    styles.backgroundColor = colorHex
  }

  if (border) {
    colorClass = legendBorderColor(color)
  }

  return (
    <div className={'flex items-center text-gray-400 text-xs ' + className}>
      <div className={'rounded-full w-2 h-2 flex-shrink-0 mr-2' + ' ' + (colorHex === null ? colorClass : '')} style={styles} />
      <Text wrap={false}>{children}</Text>
    </div>
  )
}

LegendItem.defaultProps = {
  color: 'bg-primary-500'
}

LegendItem.propTypes = {
  /**
     * Controls the color of the legend item's circle
     * Default colors: 'green' and 'orange'
     * Can also use any tailwvind bg-color e.g. bg-primary-500
     */
  color: PropTypes.string
}

export default LegendItem
